export const allProjects = [
  {
    name: 'Toppers Academy',
    desc: 'Complete online learning platform with live classes, course management, test series, and student dashboard.',
    fullDesc: 'Toppers Academy is a full-featured LMS built for competitive exam preparation. Features include live classes via video streaming, a comprehensive course library, auto-graded test series, real-time leaderboards, and a student progress dashboard. The platform scaled to over 1,000 active students within the first year.',
    tech: ['React.js', 'Node.js', 'Firebase', 'WebRTC'],
    scale: '1,000+ active students',
    url: 'https://toppersacademy.web.app/',
    image: 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&h=500&fit=crop&q=80',
    cat: 'Education',
  },
  {
    name: 'Brainbeans Portal',
    desc: 'International learning portal for Australia with video content delivery and assessments.',
    fullDesc: 'Brainbeans Portal is an international EdTech platform built for an Australian client. The system supports video-on-demand course delivery, interactive quizzes, certificate generation, and a parent monitoring portal. Designed to handle multiple time zones and comply with Australian education standards.',
    tech: ['React.js', 'Node.js', 'AWS', 'CloudFront'],
    scale: 'International (Australia)',
    url: 'https://portal.brainbeans.com.au/',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&h=500&fit=crop&q=80',
    cat: 'Education',
  },
  {
    name: 'GK Academy',
    desc: 'Mobile learning app with live classes, recorded courses, and interactive quizzes.',
    fullDesc: 'GK Academy is a React Native mobile application for competitive exam preparation. It supports HD live classes, downloadable recorded sessions, chapter-wise MCQ practice, rank-based leaderboards, and push notifications for classes and results. Published on Google Play Store with 5,000+ downloads.',
    tech: ['React Native', 'Node.js', 'MongoDB', 'Firebase'],
    scale: '5,000+ downloads',
    url: 'https://play.google.com/store/apps/details?id=com.gkacademy.liveclasses',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=500&fit=crop&q=80',
    cat: 'Mobile App',
  },
  {
    name: 'FieldSight CRM',
    desc: 'AI-powered CRM platform with intelligent insights and customer interaction automation.',
    fullDesc: 'FieldSight CRM is an enterprise-grade customer relationship management platform powered by AI. It features predictive lead scoring, automated follow-up sequences, AI-generated sales insights, field agent GPS tracking, and custom reporting dashboards. Built for a mid-size enterprise with 50+ sales agents.',
    tech: ['React.js', 'Python', 'TensorFlow', 'PostgreSQL'],
    scale: 'Enterprise – 50+ agents',
    url: '#',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop&q=80',
    cat: 'AI & CRM',
  },
  {
    name: 'NeuroNest',
    desc: 'AI-powered adaptive learning platform for JEE/NEET with personalised study plans.',
    fullDesc: 'NeuroNest is an intelligent learning platform for JEE and NEET aspirants. The AI engine analyses student performance data to generate personalised daily study plans, predict weak topics, and recommend targeted practice. Includes doubt-solving via chat, mock test analytics, and a peer comparison engine.',
    tech: ['React.js', 'Python', 'Machine Learning', 'FastAPI'],
    scale: 'Adaptive platform',
    url: '#',
    image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&h=500&fit=crop&q=80',
    cat: 'Education',
  },
  {
    name: 'E-Commerce Platform',
    desc: 'Full-featured online shopping platform with payment integration and inventory management.',
    fullDesc: 'A complete multi-vendor e-commerce solution with product catalogue management, real-time inventory tracking, Stripe and Razorpay payment gateways, GST-compliant invoice generation, order tracking, and a vendor dashboard. Handles 500+ products across multiple categories with automated restock alerts.',
    tech: ['React.js', 'Node.js', 'MongoDB', 'Stripe', 'Razorpay'],
    scale: '500+ products',
    url: '#',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=500&fit=crop&q=80',
    cat: 'E-Commerce',
  },
  {
    name: 'Healthcare Management',
    desc: 'Comprehensive clinic management with patient records, appointments, and billing.',
    fullDesc: 'A full healthcare management system for multi-branch clinics. Covers patient registration, medical history records, doctor scheduling, appointment booking with SMS reminders, diagnostic report uploads, pharmacy inventory, and automated GST billing. Deployed across 3 clinic locations in Karnataka.',
    tech: ['React.js', 'Django', 'PostgreSQL', 'Celery'],
    scale: '3-clinic deployment',
    url: '#',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=500&fit=crop&q=80',
    cat: 'Healthcare',
  },
  {
    name: 'Real Estate Portal',
    desc: 'Property listing and management platform with virtual tours and advanced search.',
    fullDesc: 'A full-stack real estate marketplace supporting property listings, advanced geo-filter search, virtual 360° tour integration, buyer–seller messaging, EMI calculators, and an agent dashboard. 1,000+ active listings with map-based property discovery and lead management for real estate agents.',
    tech: ['React.js', 'Node.js', 'AWS S3', 'Google Maps'],
    scale: '1,000+ listings',
    url: '#',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=500&fit=crop&q=80',
    cat: 'Real Estate',
  },
  {
    name: 'Restaurant Management',
    desc: 'Complete restaurant solution with menu management, orders, and delivery tracking.',
    fullDesc: 'A complete SaaS solution for restaurant chains covering digital menu management, QR-based table ordering, kitchen display system (KDS), delivery partner integration, real-time order tracking for customers, and a detailed analytics dashboard for management. Live at 50+ restaurants.',
    tech: ['React Native', 'Node.js', 'Firebase', 'Socket.io'],
    scale: '50+ restaurants',
    url: '#',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&h=500&fit=crop&q=80',
    cat: 'Food & Beverage',
  },
  {
    name: 'HR & Payroll System',
    desc: 'Automated HR management with employee tracking, payroll, and leave management.',
    fullDesc: 'An enterprise HR and payroll platform covering employee onboarding, attendance tracking via biometric integration, automated salary calculation with PF/ESI deductions, leave management workflows, performance review cycles, and statutory compliance reporting. Handles payroll for 200+ employees.',
    tech: ['React.js', 'Node.js', 'MySQL', 'Puppeteer'],
    scale: '200+ employee payroll',
    url: '#',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=500&fit=crop&q=80',
    cat: 'Enterprise',
  },
  {
    name: 'Fitness Tracking App',
    desc: 'Mobile fitness app with workout plans, calorie tracking, and progress analytics.',
    fullDesc: 'A comprehensive fitness companion app featuring AI-generated workout plans based on fitness goals, calorie intake tracking with a food database, body measurement logs, progress photos timeline, social challenges, and wearable device integration. 10,000+ users across iOS and Android.',
    tech: ['React Native', 'Node.js', 'MongoDB', 'HealthKit'],
    scale: '10,000+ users',
    url: '#',
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&h=500&fit=crop&q=80',
    cat: 'Health & Fitness',
  },
  {
    name: 'Institutional Websites',
    desc: 'Portfolio and business websites for educational institutions with CMS.',
    fullDesc: 'A portfolio of professional websites built for educational institutions, coaching centres, and businesses. Each includes a custom CMS for admins to update content, SEO optimisation, Google Analytics integration, admission/enquiry forms, gallery management, and mobile-responsive design. Delivered for multiple institutions across Karnataka.',
    tech: ['React.js', 'WordPress', 'PHP', 'MySQL'],
    scale: 'Multiple institutions',
    url: '#',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=500&fit=crop&q=80',
    cat: 'Web Development',
  },
];

export const categories = ['All', ...Array.from(new Set(allProjects.map((p) => p.cat)))];
